import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Multi-prompter composer — the "posting as <identity>" dropdown +
// auto-resizing textarea + send button. Mirrors the mockup. Returns
// drafted text via onSend; identity selection via onSelectAs.
import { useEffect, useRef, useState } from "react";
import { Icon } from "./icons.js";
export function Composer({ roster, participants, as, onSelectAs, onSend, model, busy = false, onStop, placeholder, }) {
    const [draft, setDraft] = useState("");
    const [pickerOpen, setPickerOpen] = useState(false);
    const taRef = useRef(null);
    const asPerson = roster[as];
    useEffect(() => {
        const ta = taRef.current;
        if (!ta)
            return;
        ta.style.height = "auto";
        ta.style.height = Math.min(140, ta.scrollHeight) + "px";
    }, [draft]);
    const send = () => {
        const text = draft.trim();
        if (!text)
            return;
        onSend(text);
        setDraft("");
    };
    const onKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            send();
        }
    };
    if (!asPerson)
        return null;
    return (_jsxs("div", { className: "composer", children: [_jsxs("div", { className: "composer__as", style: { position: "relative" }, children: [_jsx("span", { children: "posting as" }), _jsxs("button", { type: "button", className: "composer__as-pick", onClick: () => setPickerOpen((o) => !o), children: [_jsx("span", { className: "dot", style: { background: `var(${asPerson.colorVar})` } }), asPerson.name, _jsx("span", { style: { width: 7, height: 7, display: "inline-block" }, children: _jsx(Icon.chev, {}) })] }), pickerOpen && (_jsx("div", { className: "idpick", children: participants.map((id) => {
                            const p = roster[id];
                            if (!p)
                                return null;
                            return (_jsxs("div", { className: `idpick__row ${id === as ? "idpick__row--active" : ""}`, onClick: () => {
                                    onSelectAs(id);
                                    setPickerOpen(false);
                                }, children: [_jsx("span", { className: "dot", style: { background: `var(${p.colorVar})` } }), p.name] }, id));
                        }) }))] }), _jsxs("div", { className: "composer__box", children: [_jsx("textarea", { ref: taRef, className: "composer__input", placeholder: placeholder ?? `Message agent as ${asPerson.name}…`, value: draft, rows: 1, onChange: (e) => setDraft(e.target.value), onKeyDown: onKeyDown }), busy && onStop ? (_jsxs("button", { type: "button", className: "composer__send", onClick: onStop, title: "Stop", children: ["stop ", _jsx(Icon.stop, {})] })) : (_jsxs("button", { type: "button", className: "composer__send", disabled: !draft.trim(), onClick: send, children: ["send ", _jsx(Icon.send, {})] }))] }), _jsxs("div", { className: "composer__meta", children: [_jsx("span", { children: "\u21B5 send \u00B7 \u21E7\u21B5 newline" }), model && _jsx("span", { children: model })] })] }));
}
//# sourceMappingURL=Composer.js.map